module.exports = __webpack_public_path__ + "static/img/top.0e680e8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/top.webp
// module id = MqTQ
// module chunks = 1